import { render, staticRenderFns } from "./BuildingPositions.vue?vue&type=template&id=82ff97c0&"
import script from "./BuildingPositions.vue?vue&type=script&lang=js&"
export * from "./BuildingPositions.vue?vue&type=script&lang=js&"
import style0 from "./BuildingPositions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports